import React from 'react';

const ActivityLogSkeleton = () => {
  return (
    <div className="flex w-full items-start justify-between gap-2 pl-4">
      <div className="flex flex-1 items-start gap-2">
        <div className="h-8 w-8 animate-pulse rounded-full bg-neutral-200" />
        <div className="flex w-full flex-col gap-1">
          <div className="h-4 w-32 animate-pulse rounded bg-neutral-200" />
          <div className="h-4 w-48 animate-pulse rounded bg-neutral-200" />
        </div>
      </div>
      <div className="h-4 w-16 animate-pulse rounded bg-neutral-200" />
    </div>
  );
};

export default ActivityLogSkeleton;
